/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { AttachmentCreateRequest } from '../types/AttachmentCreate';
import type { AttachmentCreateResponse } from '../types/AttachmentCreate';

export type AttachmentsCreateRequest = AttachmentCreateRequest;
export type AttachmentsCreateResponse = AttachmentCreateResponse;

export type AttachmentsCreateQuery = {};

/**
 * POST /dmx-server/attachments/
 *
 * ```yaml
 * operationId: attachments_create
 * tags:
 *   - attachments
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentCreate'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/AttachmentCreate'
 *     description: ''
 * ```
 */
export const attachmentsCreateOperation = (rest?: AttachmentsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/attachments/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/attachments/' };
  };

/**
 * POST /dmx-server/attachments/
 *
 * ```yaml
 * operationId: attachments_create
 * tags:
 *   - attachments
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/AttachmentCreate'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/AttachmentCreate'
 *     description: ''
 * ```
 */
export const attachmentsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: AttachmentsCreateQuery;
  request: AttachmentCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<AttachmentCreateResponse>> => {
  const operation = attachmentsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
